import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {authLoader} from '../../loader';
import {ROUTE_ORDERS_REPORT} from '../../RoutePathConstant';

const OrdersReport = lazy(() =>
  import('../../../screens/OrdersReport')
    .then(module => ({default: module.OrdersReport})));

const OrdersReportNavigation = [
  {
    path:  ROUTE_ORDERS_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <OrdersReport />
      </Suspense>
    ),
  },
];

export default OrdersReportNavigation;
